/* ======================================================================================================================
   KONFIGURATOR – Zubehör (Upsell in den Schritten)
   Nachttische im Stoff und in der Farbe des Betts, Spannbettlaken in der Bettgröße, Bettwäsche passend zur Breite,
   Nackenkissen. Die Produktdaten kommen zur Laufzeit aus /products/<handle>.js (öffentlich, immer aktuelle Preise und
   Verfügbarkeit) – so hängt der Konfigurator nicht am all_products-Limit von Liquid und lädt nur, was der jeweilige
   Schritt braucht. Gewähltes Zubehör liegt im Alpine-Store `bedAddons` (sessionStorage je Konfigurator) und wird beim
   „In den Warenkorb“ unmittelbar vor dem Bett per /cart/add.js in den Warenkorb gelegt.

   Regeln (Vorgabe Luxusbetten24):
   - Boxspringbett: Nachttisch immer in der passenden Variante (gleicher Stoff, gleiche Farbe) – gibt es den Stoff
     oder die Farbe nicht als Nachttisch, wird keiner angeboten.
   - Polsterbett (Produkt 15322601947511): Samt ist ein anderer Stoff als beim Nachttisch – Nachttische nur bei
     Bouclé und Cord.
   - Laken, Bettwäsche und Kissen immer, sofern eine passende Größe verfügbar ist.
   ====================================================================================================================== */
(function () {
  'use strict';

  var UPHOLSTERED_PRODUCT_ID = 15322601947511;

  var CATALOG = {
    nightstands: {
      samt: [
        { handle: 'designer-nachttisch-josy', name: 'Josy' },
        { handle: 'designer-nachttisch-josy-charge-in-samt', name: 'Josy Charge' },
        { handle: 'designer-nachttisch-amy', name: 'Amy' },
        { handle: 'designer-nachttisch-lilly-mit-usb-anschluss', name: 'Lilly mit USB' },
      ],
      boucle: [
        { handle: 'designer-nachttisch-josy-in-boucle', name: 'Josy' },
        { handle: 'designer-nachttisch-josy-charge-in-boucle', name: 'Josy Charge' },
        { handle: 'designer-nachttisch-amy-in-boucle', name: 'Amy' },
        { handle: 'designer-nachttisch-lilly-mit-usb-anschluss-in-boucle', name: 'Lilly mit USB' },
      ],
      cord: [
        { handle: 'designer-nachttisch-amy-in-cord', name: 'Amy' },
        { handle: 'designer-nachttisch-lilly-mit-usb-anschluss-in-cord', name: 'Lilly mit USB' },
      ],
      strukturstoff: [
        { handle: 'designer-nachttisch-amy-in-strukturstoff', name: 'Amy' },
        { handle: 'designer-nachttisch-lilly-mit-usb-anschluss-in-strukturstoff', name: 'Lilly mit USB' },
      ],
    },
    sheets: [
      { handle: 'premium-boxspring-bettlaken-jersey', name: 'Jersey' },
      { handle: 'premium-boxspring-bettlaken-frotte', name: 'Frotte' },
      { handle: 'premium-boxsprung-bettlaken-lycra', name: 'Lycra' },
    ],
    bedding: [
      { handle: 'premium-satin-bettwasche-weiss', name: 'Satin Weiß' },
      { handle: 'premium-satin-bettwasche-hellgrau', name: 'Satin Hellgrau' },
      { handle: 'premium-satin-bettwasche-dunkelgrau', name: 'Satin Anthrazit' },
      { handle: 'bettwasche-set-beige-100-baumwolle-ranforce', name: 'Beige · Baumwolle' },
    ],
    pillows: [
      { handle: 'nightsense™-nackenkissen-air', name: 'NightSense AIR' },
      { handle: 'nightsense™-nackenstutzkissen-visco', name: 'NightSense VISCO' },
      { handle: 'nackenstutzkissen-loria', name: 'Loria' },
    ],
    // Stoffpflege im Stoff-Schritt – für alle Textilbezüge; bei Kunstleder (kein Textil) wird nichts angeboten
    care: [
      { handle: 'luxusbetten24®-textilimpragnierer', name: 'Textilimprägnierer', meta: 'Imprägnieren, bevor der erste Fleck kommt' },
      { handle: 'polssterreiniger', name: 'Polsterreiniger mit Duft', meta: 'Für Flecken und zum Auffrischen' },
    ],
  };

  function norm(value) {
    return String(value == null ? '' : value).trim().toLowerCase()
      .replace(/ß/g, 'ss').replace(/é/g, 'e').replace(/\s+/g, ' ');
  }

  function fabricFamily(label) {
    var key = norm(label);
    if (!key) return null;
    if (key.indexOf('boucle') >= 0) return 'boucle';
    if (key.indexOf('cord') >= 0) return 'cord';
    if (key.indexOf('struktur') >= 0) return 'strukturstoff';
    if (key.indexOf('samt') >= 0 || key.indexOf('velvet') >= 0) return 'samt';
    return null;
  }

  function routeRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' && root ? root : '/';
  }

  function imageUrl(src, width) {
    if (!src) return '';
    var url = String(src);
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + width);
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  function variantImage(product, variant) {
    var src = variant && variant.featured_image && variant.featured_image.src;
    if (!src) src = product && product.featured_image;
    return imageUrl(src, 320);
  }

  function storageKey() {
    var productId = window.maisonBedConfigurator && window.maisonBedConfigurator.productId;
    return 'cx-addons:' + (productId || 'bed');
  }

  function register() {
    if (!window.Alpine || register.done) return;
    register.done = true;

    Alpine.store('bedAddons', {
      products: {},   // handle -> product JSON | null (null = nicht ladbar)
      pending: {},    // handle -> Promise
      picked: {},     // key -> {key, group, handle, variantId, qty, name, meta, price, image}
      choice: {},     // Laken: handle -> gewählte Variant-ID (Farbe)
      loadedGroups: {},
      submitError: null,

      // ---- Bett-Kontext --------------------------------------------------------------------------------------------
      get upholstered() {
        return !!(window.maisonBedConfigurator && window.maisonBedConfigurator.productId === UPHOLSTERED_PRODUCT_ID);
      },
      bed() {
        var config = Alpine.store('bedConfig') || {};
        var summary = Alpine.store('bedConfigSummary') || {};
        var props = summary.properties || {};
        return {
          width: parseInt(config.width, 10) || 0,
          length: parseInt(config.length, 10) || 0,
          fabric: props['Stofftyp'] || '',
          color: props['Stofffarbe'] || '',
        };
      },
      // Elektrische Schlaffunktion (Boxspring) bzw. elektrischer Lattenrost (Polsterbett) = zwei einzelne Matratzen,
      // die sich getrennt bewegen – dann braucht jede Matratze ihr eigenes Laken in halber Breite.
      splitMattress() {
        var config = Alpine.store('bedConfig') || {};
        return config.frame === 'elektrisch';
      },
      sheetWidth() {
        var bed = this.bed();
        if (!bed.width) return 0;
        return this.splitMattress() ? bed.width / 2 : bed.width;
      },
      sheetQty() { return this.splitMattress() ? 2 : 1; },
      sizeKey() {
        var bed = this.bed();
        var width = this.sheetWidth();
        return width && bed.length && width === Math.floor(width) ? width + 'x' + bed.length : '';
      },
      sizeLabel() {
        var bed = this.bed();
        var width = this.sheetWidth();
        if (!width || !bed.length) return '';
        return (this.splitMattress() ? '2 × ' : '') + width + ' × ' + bed.length + ' cm';
      },
      nightstandFamily() {
        var family = fabricFamily(this.bed().fabric);
        if (!family || !CATALOG.nightstands[family]) return null;
        if (this.upholstered && family !== 'boucle' && family !== 'cord') return null;
        return family;
      },
      careApplies() {
        var key = norm(this.bed().fabric);
        return !!key && key.indexOf('leder') < 0;
      },
      beddingSizes() {
        var width = this.bed().width;
        if (!width) return [];
        if (width <= 140) return ['135x200'];
        if (width <= 160) return ['155x200'];
        return ['200x200', '200x220'];
      },

      // ---- Laden ---------------------------------------------------------------------------------------------------
      handlesFor(group) {
        if (group === 'nightstands') {
          var family = this.nightstandFamily();
          return family ? CATALOG.nightstands[family].map(function (d) { return d.handle; }) : [];
        }
        if (group === 'care' && !this.careApplies()) return [];
        return (CATALOG[group] || []).map(function (d) { return d.handle; });
      },
      load(groups) {
        var self = this;
        var handles = [];
        (Array.isArray(groups) ? groups : String(groups || '').split(',')).forEach(function (group) {
          group = group.trim();
          if (!group) return;
          self.handlesFor(group).forEach(function (handle) { if (handles.indexOf(handle) < 0) handles.push(handle); });
        });
        return Promise.all(handles.map(function (handle) { return self.loadProduct(handle); }));
      },
      loadProduct(handle) {
        var self = this;
        if (Object.prototype.hasOwnProperty.call(this.products, handle)) return Promise.resolve(this.products[handle]);
        if (this.pending[handle]) return this.pending[handle];
        var url = routeRoot() + 'products/' + encodeURIComponent(handle) + '.js';
        var request = fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; })
          .then(function (product) {
            self.products[handle] = product && Array.isArray(product.variants) ? product : null;
            delete self.pending[handle];
            return self.products[handle];
          });
        this.pending[handle] = request;
        return request;
      },

      // ---- Angebote je Gruppe (reaktiv: lesen products + Bett-Kontext) -------------------------------------------
      nightstands() {
        var family = this.nightstandFamily();
        if (!family) return [];
        var bed = this.bed();
        var color = norm(bed.color);
        if (!color) return [];
        var self = this;
        var offers = [];
        CATALOG.nightstands[family].forEach(function (def) {
          var product = self.products[def.handle];
          if (!product) return;
          var variant = null;
          for (var i = 0; i < product.variants.length; i++) {
            var candidate = product.variants[i];
            if (candidate.available && norm(candidate.option1) === color) { variant = candidate; break; }
          }
          if (!variant) return;
          offers.push({
            key: 'ns:' + def.handle,
            group: 'nightstands',
            handle: def.handle,
            name: 'Nachttisch ' + def.name,
            meta: bed.fabric + ' · ' + variant.option1,
            variantId: variant.id,
            price: variant.price,
            image: variantImage(product, variant),
            url: routeRoot() + 'products/' + def.handle + '?variant=' + variant.id,
          });
        });
        return offers;
      },
      sheets() {
        var size = this.sizeKey();
        if (!size) return [];
        var self = this;
        var offers = [];
        CATALOG.sheets.forEach(function (def) {
          var product = self.products[def.handle];
          if (!product) return;
          var colors = product.variants.filter(function (variant) { return variant.available && variant.option1 === size; })
            .map(function (variant) { return { id: variant.id, title: variant.option2, price: variant.price }; });
          if (!colors.length) return;
          var chosen = colors.filter(function (c) { return c.id === self.choice[def.handle]; })[0];
          if (!chosen) chosen = colors.filter(function (c) { return norm(c.title) === 'weiss'; })[0] || colors[0];
          var qty = self.sheetQty();
          offers.push({
            key: 'sheet:' + def.handle,
            group: 'sheets',
            handle: def.handle,
            name: 'Spannbettlaken ' + def.name,
            colors: colors,
            variantId: chosen.id,
            variantTitle: chosen.title,
            qty: qty,
            meta: (qty > 1 ? qty + ' × ' : '') + size.replace('x', ' × ') + ' cm · ' + chosen.title + (qty > 1 ? ' – eins je Matratze' : ''),
            price: chosen.price,
            image: imageUrl(product.featured_image, 160),
            url: routeRoot() + 'products/' + def.handle + '?variant=' + chosen.id,
          });
        });
        return offers;
      },
      bedding() {
        var sizes = this.beddingSizes();
        if (!sizes.length) return [];
        var self = this;
        var offers = [];
        CATALOG.bedding.forEach(function (def) {
          var product = self.products[def.handle];
          if (!product) return;
          var variant = null;
          for (var s = 0; s < sizes.length && !variant; s++) {
            for (var i = 0; i < product.variants.length; i++) {
              var candidate = product.variants[i];
              if (candidate.available && candidate.option1 === sizes[s]) { variant = candidate; break; }
            }
          }
          if (!variant) return;
          offers.push({
            key: 'bedding:' + def.handle,
            group: 'bedding',
            handle: def.handle,
            name: 'Bettwäsche ' + def.name,
            meta: String(variant.option1).replace('x', ' × ') + ' cm',
            variantId: variant.id,
            price: variant.price,
            image: variantImage(product, variant),
            url: routeRoot() + 'products/' + def.handle + '?variant=' + variant.id,
          });
        });
        return offers;
      },
      pillows() {
        var self = this;
        var offers = [];
        CATALOG.pillows.forEach(function (def) {
          var product = self.products[def.handle];
          if (!product) return;
          var variant = product.variants.filter(function (v) { return v.available; })[0];
          if (!variant) return;
          offers.push({
            key: 'pillow:' + def.handle,
            group: 'pillows',
            handle: def.handle,
            name: def.name,
            meta: 'Nackenstützkissen',
            variantId: variant.id,
            price: variant.price,
            image: imageUrl(product.featured_image, 160),
            url: routeRoot() + 'products/' + def.handle,
          });
        });
        return offers;
      },

      care() {
        if (!this.careApplies()) return [];
        var self = this;
        var offers = [];
        CATALOG.care.forEach(function (def) {
          var product = self.products[def.handle];
          if (!product) return;
          var variant = product.variants.filter(function (v) { return v.available; })[0];
          if (!variant) return;
          offers.push({
            key: 'care:' + def.handle,
            group: 'care',
            handle: def.handle,
            name: def.name,
            meta: def.meta,
            variantId: variant.id,
            price: variant.price,
            image: imageUrl(product.featured_image, 160),
            url: routeRoot() + 'products/' + def.handle,
          });
        });
        return offers;
      },

      // ---- Auswahl -------------------------------------------------------------------------------------------------
      isPicked(key) { return !!this.picked[key]; },
      pickedQty(key) { return this.picked[key] ? this.picked[key].qty : 0; },
      setChoice(offer, variantId) {
        var id = parseInt(variantId, 10);
        if (!id) return;
        this.choice[offer.handle] = id;
        // Liegt das Laken schon in der Auswahl, folgt die Auswahl der neuen Farbe
        var pick = this.picked[offer.key];
        if (pick) {
          var color = offer.colors.filter(function (c) { return c.id === id; })[0];
          if (color) {
            pick.variantId = id;
            pick.price = color.price;
            pick.meta = offer.meta.replace(offer.variantTitle, color.title);
            this.persist();
          }
        }
      },
      add(offer, qty) {
        this.picked[offer.key] = {
          key: offer.key, group: offer.group, handle: offer.handle, variantId: offer.variantId,
          qty: Math.max(1, parseInt(qty, 10) || 1), name: offer.name, meta: offer.meta, price: offer.price, image: offer.image,
        };
        this.persist();
      },
      remove(key) {
        if (!this.picked[key]) return;
        delete this.picked[key];
        this.persist();
      },
      toggle(offer, qty) {
        if (this.picked[offer.key]) this.remove(offer.key); else this.add(offer, qty);
      },
      setQty(key, qty) {
        var pick = this.picked[key];
        if (!pick) return;
        pick.qty = Math.max(1, parseInt(qty, 10) || 1);
        this.persist();
      },
      get items() {
        var self = this;
        return Object.keys(this.picked).map(function (key) { return self.picked[key]; });
      },
      get count() {
        return this.items.reduce(function (sum, item) { return sum + item.qty; }, 0);
      },
      get total() {
        return this.items.reduce(function (sum, item) { return sum + item.price * item.qty; }, 0);
      },
      // Auswahl, die zur geänderten Konfiguration nicht mehr passt, fällt raus (anderer Stoff/Farbe, andere Größe)
      prune() {
        var self = this;
        var valid = {};
        this.nightstands().forEach(function (o) { valid[o.key] = o; });
        this.sheets().forEach(function (o) { valid[o.key] = o; });
        this.bedding().forEach(function (o) { valid[o.key] = o; });
        this.pillows().forEach(function (o) { valid[o.key] = o; });
        this.care().forEach(function (o) { valid[o.key] = o; });
        var changed = false;
        Object.keys(this.picked).forEach(function (key) {
          var pick = self.picked[key];
          var offer = valid[key];
          var groupLoaded = self.handlesFor(pick.group).some(function (h) { return Object.prototype.hasOwnProperty.call(self.products, h); });
          if (!groupLoaded) return; // noch nichts geladen – nicht vorschnell löschen
          if (!offer) { delete self.picked[key]; changed = true; return; }
          if (pick.group !== 'sheets' && offer.variantId !== pick.variantId) {
            pick.variantId = offer.variantId; pick.price = offer.price; pick.meta = offer.meta; pick.image = offer.image; changed = true;
          }
          if (pick.group === 'sheets' && !offer.colors.some(function (c) { return c.id === pick.variantId; })) {
            pick.variantId = offer.variantId; pick.price = offer.price; pick.meta = offer.meta; changed = true;
          }
          if (pick.group === 'sheets' && pick.qty !== offer.qty) {
            pick.qty = offer.qty; pick.meta = offer.meta; changed = true;
          }
        });
        if (changed) this.persist();
      },

      // ---- Persistenz (Session) ------------------------------------------------------------------------------------
      persist() {
        try { window.sessionStorage.setItem(storageKey(), JSON.stringify({ picked: this.picked, choice: this.choice })); } catch (error) {}
      },
      restore() {
        try {
          var raw = window.sessionStorage.getItem(storageKey());
          if (!raw) return;
          var data = JSON.parse(raw);
          if (data && data.picked && typeof data.picked === 'object') this.picked = data.picked;
          if (data && data.choice && typeof data.choice === 'object') this.choice = data.choice;
        } catch (error) {}
      },
      clear() {
        this.picked = {};
        this.persist();
      },

      // ---- Warenkorb -----------------------------------------------------------------------------------------------
      // Wird vom Konfigurator unmittelbar vor dem Bett-Submit aufgerufen. Wirft bei Fehler – der Konfigurator zeigt
      // dann die Fehlermeldung mit „Erneut versuchen“, statt das Bett ohne das gewählte Zubehör abzuschicken.
      submitToCart(signal) {
        var items = this.items.map(function (item) { return { id: item.variantId, quantity: item.qty }; });
        if (!items.length) return Promise.resolve(null);
        var self = this;
        this.submitError = null;
        return fetch(routeRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
          signal: signal,
        }).then(function (response) {
          if (!response.ok) throw new Error('Zubehör konnte nicht in den Warenkorb gelegt werden.');
          self.clear();
          return response.json().catch(function () { return null; });
        });
      },

      money(cents) {
        return typeof window.mcFormatMoney === 'function' ? window.mcFormatMoney(cents, null, true) : (cents / 100).toFixed(2) + ' €';
      },
    });

    Alpine.store('bedAddons').restore();

    // Panel je Schritt: lädt die Produktdaten seiner Gruppen, sobald der Schritt aktiv ist
    Alpine.data('bedAddonsPanel', function (groups) {
      return {
        groups: String(groups || '').split(',').map(function (g) { return g.trim(); }).filter(Boolean),
        loaded: false,
        has(group) { return this.groups.indexOf(group) >= 0; },
        load() {
          var self = this;
          this.$store.bedAddons.load(this.groups).then(function () {
            self.loaded = true;
            self.$store.bedAddons.prune();
          });
        },
        offers(group) { return this.$store.bedAddons[group](); },
        // Mindestens eine Gruppe hat ein Angebot – sonst bleibt der ganze Block ausgeblendet
        hasOffers() {
          var self = this;
          return this.groups.some(function (g) {
            return typeof self.$store.bedAddons[g] === 'function' && self.$store.bedAddons[g]().length > 0;
          });
        },
        nsQty: {},
        qtyFor(key) { return this.nsQty[key] || 2; },
        setNsQty(offer, qty) {
          this.nsQty[offer.key] = qty;
          if (this.$store.bedAddons.isPicked(offer.key)) this.$store.bedAddons.setQty(offer.key, qty);
        },
      };
    });
  }

  // Alpine kommt deferred aus dem Head: ist es schon da, sofort registrieren, sonst auf alpine:init warten
  if (window.Alpine && typeof window.Alpine.store === 'function') register();
  else window.addEventListener('alpine:init', register);
})();
